import { Injectable, OnDestroy } from '@angular/core';

import { filter, mergeMap, takeUntil, tap } from 'rxjs/operators';
import { iif, interval, Subject } from 'rxjs';

import { DATA_IFRAME_ATTR, DATA_IFRAME_CLICK_ATTR } from '@views/pages/export-report/export-report.component';
import { empty } from '@core/_utils/empty';

import { ClicksMetricService } from './clicks-metric.service';

const findIframe = () => document.querySelectorAll(`iframe`);
const powerbiClientIframe = () => document.querySelector(`[${DATA_IFRAME_ATTR}]`);
const powerbiClientIframeIsActive = () => !!document.querySelector(`[${DATA_IFRAME_CLICK_ATTR}]`);
const baseIframeIsActive = () => [].includes.call(findIframe(), document.activeElement);

const powerbiClientIframeIsExist = () => !!powerbiClientIframe();

Injectable({ providedIn: 'root' });
export class IframeTrackClicksService implements OnDestroy {
  private unsubscribe$ = new Subject();
  constructor(private clicksMonitoringService: ClicksMetricService) {}

  public detectClickOnIframe() {
    const trackActionOnBase$ = empty().pipe(filter(baseIframeIsActive), tap(this.writeClickOnBaseIframe));
    const trackActionOnPowerbiClient$ = empty().pipe(
      filter(powerbiClientIframeIsActive),
      tap(this.writeClickOnIframePowerBiClient),
    );

    interval(200)
      .pipe(
        mergeMap(() => iif(powerbiClientIframeIsExist, trackActionOnPowerbiClient$, trackActionOnBase$)),
        takeUntil(this.unsubscribe$),
      )
      .subscribe();
  }

  private writeClickOnIframePowerBiClient = () => {
    this.clicksMonitoringService.incrementDashboardClicks();
    powerbiClientIframe().removeAttribute(DATA_IFRAME_CLICK_ATTR);
  };

  private writeClickOnBaseIframe = () => {
    this.clicksMonitoringService.incrementDashboardClicks();
    // @ts-ignore
    document.activeElement.blur();
  };

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
